import { lazy } from "react";
import i18n from "i18next";
import type { GameModule } from "../types";
import { MERGE_TILES_NS, registerMergeTilesTranslations } from "./i18n";

registerMergeTilesTranslations(i18n);

/** 2048. Keyed `merge_tiles`; the name people see comes from i18n. */
export const mergeTilesModule: GameModule = {
  key: "merge_tiles",
  namespace: MERGE_TILES_NS,
  Player: lazy(() => import("./Player")),
};
